import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { Body } from 'shared-global-ec-uikit/components/dist/react/esm/components/body'
import { ContentAlignment } from 'shared-global-ec-uikit/components/dist/react/esm/components/content-alignment'
import { Accessibility, StoreSize } from 'services/Stores/constants'
import { List } from 'shared-global-ec-uikit/components/dist/react/esm/components/list'
import { ImageTypography } from 'shared-global-ec-uikit/components/dist/react/esm/components/image-typography'
import {
  Display,
  IconTypography,
} from 'shared-global-ec-uikit/components/dist/react/esm'

const StoreCategories = (props: any) => {
  const getStoreTypeText = (text: string) => {
    switch (text) {
      case StoreSize.extraLarge:
        return <FormattedMessage id="text_megastore" />

      case StoreSize.large:
        return <FormattedMessage id="text_largestore" />

      case StoreSize.standard:
        return <FormattedMessage id="text_standard_store" />

      case StoreSize.small:
        return <FormattedMessage id="text_small_store" />

      default:
        return ''
    }
  }

  const renderCategoryData = (props: any) => {
    return (
      <div>
        <ContentAlignment alignment="center" direction="row" element="div">
          <IconTypography icon="size" iconColor="standard" iconPosition="start">
            <Body color="primary-dark" element="p" variant="standard">
              {props.intl.formatMessage({ id: 'text_store_locator_products' })}
            </Body>
          </IconTypography>
        </ContentAlignment>
        <List
          element="ul"
          variant="primary"
          className="fr-ec-mt-spacing-02 fr-ec-mb-spacing-02"
          style={{ marginLeft: '2em' }}
        >
          {props.storeInfo.productTypeList.map((item: any) => {
            return <li key={item.name}>{item.name}</li>
          })}
        </List>
      </div>
    )
  }

  const renderInStoreService = (props: any) => {
    return (
      <div>
        <ContentAlignment alignment="center" direction="row" element="div">
          <IconTypography icon="o2o" iconColor="standard" iconPosition="start">
            <Body color="primary-dark" element="p" variant="standard">
              {props.intl.formatMessage({
                id: 'text_store_locator_store_service',
              })}
            </Body>
          </IconTypography>
        </ContentAlignment>
        <List
          element="ul"
          variant="primary"
          className="fr-ec-mt-spacing-02 fr-ec-mb-spacing-02"
          style={{ marginLeft: '2em' }}
        >
          {props.storeInfo.clickAndCollectFlag ? (
            <li>
              {props.intl.formatMessage({
                id: 'text_store_locator_store_pick_up',
              })}
            </li>
          ) : (
            <></>
          )}
          {props.storeInfo.payAtStoreFlag ? (
            <li>
              {props.intl.formatMessage({
                id: 'text_store_locator_pay_in_store',
              })}
            </li>
          ) : (
            <></>
          )}
          {props.storeInfo.orderAndPickFlag ? (
            <li>
              {props.intl.formatMessage({
                id: 'text_store_locator_order_and_pick',
              })}
            </li>
          ) : (
            <></>
          )}
          {props.storeInfo.storeServiceFlags?.length ? (
            props.storeInfo.storeServiceFlags.map((item: any) => {
              return <li key={item.name}>{item.name}</li>
            })
          ) : (
            <></>
          )}
        </List>
      </div>
    )
  }
  const renderAccessibilityData = (props: any) => {
    const accessibilityExceptParkingArray = props.storeInfo.accessibilityFlags.filter(
      (item: any) => item.type !== Accessibility.parking,
    )
    return (
      <>
        {accessibilityExceptParkingArray.length ? (
          <div>
            <ContentAlignment alignment="center" direction="row" element="div">
              <ImageTypography
                alt={'accessibility'}
                src={`${process.env.REACT_APP_ASSET_BASE_URL}/g/icons/accessibility.svg`}
                imageHeight="24"
                alignment="center"
              >
                <Body color="primary-dark" element="p" variant="standard">
                  {props.intl.formatMessage({ id: 'text_a11y' })}
                </Body>
              </ImageTypography>
            </ContentAlignment>
            <List
              element="ul"
              variant="primary"
              className="fr-ec-mt-spacing-02 fr-ec-mb-spacing-02"
              style={{ marginLeft: '2em' }}
            >
              {accessibilityExceptParkingArray.map((item: any) => {
                return <li key={item.name}>{item.name}</li>
              })}
            </List>
          </div>
        ) : null}
      </>
    )
  }
  const showParkingFilter = (props: any) => {
    const parkingArray = props.storeInfo.accessibilityFlags.find(
      (item: any) => item.type === Accessibility.parking,
    )
    return (
      <>
        {parkingArray?.name ? (
          <ContentAlignment alignment="center" direction="row" element="div">
            <IconTypography
              icon="parking"
              iconColor="standard"
              iconPosition="start"
            >
              <Body color="primary-dark" element="p" variant="standard">
                {parkingArray.name}
              </Body>
            </IconTypography>
          </ContentAlignment>
        ) : null}
      </>
    )
  }

  return (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
        className="fr-ec-mb-spacing-04"
      >
        {props.intl.formatMessage({ id: 'text_store_available_at' })}
      </Display>

      {props.storeInfo.storeType &&
        props.storeInfo.storeType !== StoreSize.none && (
          <>
            <ContentAlignment
              alignment="center"
              direction="row"
              element="div"
              className="fr-ec-mb-spacing-02"
            >
              <IconTypography
                icon="store"
                iconColor="standard"
                iconPosition="start"
              >
                <Body color="primary-dark" element="p" variant="standard">
                  {getStoreTypeText(props.storeInfo.storeType)}
                </Body>
              </IconTypography>
            </ContentAlignment>
          </>
        )}
      {props.storeInfo.productTypeList &&
        props.storeInfo.productTypeList.length &&
        renderCategoryData(props)}
      {(props.storeInfo.clickAndCollectFlag ||
        props.storeInfo.payAtStoreFlag ||
        props.storeInfo.orderAndPickFlag ||
        !!props.storeInfo.storeServiceFlags?.length) &&
        renderInStoreService(props)}
      {props.storeInfo.accessibilityFlags?.length
        ? renderAccessibilityData(props)
        : null}
      {props.storeInfo.accessibilityFlags?.length
        ? showParkingFilter(props)
        : null}
    </>
  )
}

export default injectIntl(StoreCategories)
